export default {"src":"/_next/static/media/helping-sm.mono.66574d9c.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};